(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.factory('defaultChartColorList', function () {
        return [
            '#0cb3ee',
            '#2e3192',
            '#ea1517',
            '#008bd2',
            '#119591',
            '#76bf43',
            '#0072c6'
        ];
    });
}());